import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/SalesContact/SalesContact.js
const SalesContact = createSectionForm({
  icon: "user-voice-line",
  title: "Sales Contact",
  fields: [
    { name: "title", label: "Title" },
    { name: "image", label: "Contact Photo", type: "media" },
    { name: "name", label: "Contact Name" },
    { name: "department", label: "Department" },
    { name: "phone", label: "Phone" },
    { name: "email", label: "Email" },
    { name: "description", label: "Message", type: "richtext" },
    {
      name: "team",
      label: "Sales Team",
      type: "list",
      itemLabel: "Team Member",
      fields: [
        { name: "image", label: "Photo", type: "media" },
        { name: "name", label: "Name" },
        { name: "info", label: "Info" },
        { name: "rating", label: "Rating", type: "number", min: 0, maxValue: 5, step: 0.5 },
        { name: "review", label: "Review", type: "textarea" },
      ],
    },
  ],
});

export default SalesContact;
